export class CustomersSuppliersSettings {
    allowedFileTypes: string[] = [];
    importAttachmentsDefault: boolean = false;
    importIndividualInvoicesDefault: boolean = false;

    deserialize(data: any): this {
        this.allowedFileTypes = (data.allowed_file_types ?? []) as string[];
        this.importAttachmentsDefault = data.import_attachments_default ?? false;
        this.importIndividualInvoicesDefault = data.import_individual_invoices_default ?? false;
        return this;
    }

    serialize(): any {
        return {
            allowed_file_types: this.allowedFileTypes,
            import_attachments_default: this.importAttachmentsDefault,
            import_individual_invoices_default: this.importIndividualInvoicesDefault,
        };
    }
}
